const setVideoEmbeds = function (playerElements) {
  /*
   * Light YouTube Embeds by @labnol
   * Credit: https://www.labnol.org/
   */
  if (!playerElements) return;
  const playerWrapperClasses = ["ratio", "ratio-16x9"];

  function replaceWithIframe(div) {
    // Removes placeholder div and sets the iframe code for a youtube video
    let iframe = document.createElement('iframe');
    iframe.setAttribute('src', 'https://www.youtube.com/embed/' + div.dataset.id + '?autoplay=1&rel=0');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '1');
    iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');

    setClasses(div.parentElement, playerWrapperClasses);
    div.parentElement.replaceChild(iframe, div);
  }

  function getYoutubePreview(player) {
    const videoId = player.dataset.id ? player.dataset.id : null;
    let div = document.createElement('div');
    if (!videoId) return div;

    div.setAttribute('data-id', videoId);
    let thumbNode = document.createElement('img');
    thumbNode.src = '//i.ytimg.com/vi/ID/hqdefault.jpg'.replace('ID', videoId);
    div.appendChild(thumbNode);


    let playButton = player.querySelector(".play-icon") ? player.querySelector(".play-icon") : null;
    if (!playButton) {
      playButton = document.createElement('span');
      playButton.setAttribute('class', 'play-icon');
      div.appendChild(playButton);
    }

    div.onclick = function () {
      // Replace placeholder with Iframe
      replaceWithIframe(this);
    };
    return div;
  }

  playerElements.map(function (elm) {
    const vidType = elm.dataset.videoType && elm.dataset.videoType != "" ? elm.dataset.videoType.trim() : 'youtube';
    switch (vidType) {
      case 'youtube':
        let vidPreview = getYoutubePreview(elm);
        elm.appendChild(vidPreview);
        break;
      default:
        //DEV: White list your video type in setVideoEmbeds() and _get-video.php
        if (elm.querySelector("iframe")) setClasses(elm, playerWrapperClasses);
    }
  });
}

window.addEventListener('load', () => {
  if (document.querySelector(".is-embedded-video")) setVideoEmbeds(Array.from(document.querySelectorAll(".is-embedded-video")));
});